module.exports = "<div class=\"snackBar\" [ngClass]=\"type\">{{msg}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/snackbar/snackbar.html
// module id = ./src/app/components/snackbar/snackbar.html
// module chunks = main